import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"
import BlueBar from "../../components/SubPages/SolutionsPage/BlueBar/blueBar"
import SideBySide from "../../components/SubPages/SolutionsPage/Sidebyside/sideBySide"

import Img from "../../images/products/meet.png"

import backgroundImg from "../../images/solutions/onlineTutoring/background.svg"

import virtualImg from "../../images/solutions/onlineTutoring/Virtual classroom 3.png"
import scheduleImg from "../../images/solutions/onlineTutoring/Schedule class 2.png"
import usermImg from "../../images/solutions/onlineTutoring/User management.png"
import reportslImg from "../../images/solutions/onlineTutoring/Reports.png"
import adminImg from "../../images/solutions/onlineTutoring/Admin.png"
import recordingdlImg from "../../images/solutions/onlineTutoring/Recordings.png"

import CarouselImg1 from "../../images/solutions/onlineTutoring/Siplo.png"
import CarouselImg2 from "../../images/solutions/onlineTutoring/Bosslr.png"

import Constants from "../../constants/solutions.json"

const carouselVideos = [
  {
    videoUrl1: "fsfsdfsdf",
    videoUrl2: "fsfsdfsdf",
    videoUrl3: "fsfsdfsdf",
  },
  {
    videoUrl1: "fsfsdfsdf",
    videoUrl2: "fsfsdfsdf",
    videoUrl3: "fsfsdfsdf",
  },
  {
    videoUrl1: "fsfsdfsdf",
    videoUrl2: "fsfsdfsdf",
    videoUrl3: "fsfsdfsdf",
  },
]

const carouselData = [
  {
    description: Constants.SOLUTIONS.onlineTutoring.carouselData.i1.description,
    img: CarouselImg2,
  },
  {
    description: Constants.SOLUTIONS.onlineTutoring.carouselData.i2.description,
    img: CarouselImg1,
  },
]

const GridData = [
  {
    title: Constants.SOLUTIONS.onlineTutoring.GridDataArray.i1.title,
    description:
      Constants.SOLUTIONS.onlineTutoring.GridDataArray.i1.description,
    img: virtualImg,
  },
  {
    title: Constants.SOLUTIONS.onlineTutoring.GridDataArray.i2.title,
    description:
      Constants.SOLUTIONS.onlineTutoring.GridDataArray.i2.description,
    img: scheduleImg,
  },
  {
    title: Constants.SOLUTIONS.onlineTutoring.GridDataArray.i3.title,
    description:
      Constants.SOLUTIONS.onlineTutoring.GridDataArray.i3.description,
    img: usermImg,
  },
  {
    title: Constants.SOLUTIONS.onlineTutoring.GridDataArray.i4.title,
    description:
      Constants.SOLUTIONS.onlineTutoring.GridDataArray.i4.description,
    img: reportslImg,
  },
  {
    title: Constants.SOLUTIONS.onlineTutoring.GridDataArray.i5.title,
    description:
      Constants.SOLUTIONS.onlineTutoring.GridDataArray.i5.description,
    img: adminImg,
  },
  {
    title: Constants.SOLUTIONS.onlineTutoring.GridDataArray.i6.title,
    description:
      Constants.SOLUTIONS.onlineTutoring.GridDataArray.i6.description,
    img: recordingdlImg,
  },
]

const onlineTutoring = () => (
  <MainLayout>
    <SEO
      title="Online Tutoring"
      description="A complete online tutoring management platform with integrate virtual classroom. Meetrix teach The digitalization of the education industry has been slow yet promising with its large market. Meetrix Teach and Meetrix Virtual Classroom make this possible by providing students, tutors and, admins a great user experience through their well-designed tools. With the experience of producing online tutoring platforms that are major platforms driving the respective countries road to the digitalization of education. 
            How to create online teaching platforms for teachers. Best remote teaching platforms."
      pagePath="/solutions/online-tutoring"
      schema={`{
              "@context": "https://meetrix.io/solutions/online-tutoring",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.SOLUTIONS.onlineTutoring.MainLayout.title}
      description={Constants.SOLUTIONS.onlineTutoring.MainLayout.description}
      blueTitle={Constants.SOLUTIONS.onlineTutoring.MainLayout.blueTitle}
      blueLink=""
      background={backgroundImg}
    />
    <GridView
      twoCol
      noButton
      title={Constants.SOLUTIONS.onlineTutoring.GridView.title}
      description={Constants.SOLUTIONS.onlineTutoring.GridView.description}
      bottomTitle={Constants.SOLUTIONS.onlineTutoring.GridView.bottomTitle}
      data={GridData}
      linkTitle={Constants.SOLUTIONS.onlineTutoring.GridView.linkTitle}
    />
    <BlueBar
      title={Constants.SOLUTIONS.onlineTutoring.blueRow.i1.title}
      description={Constants.SOLUTIONS.onlineTutoring.blueRow.i1.description}
    />
    <SideBySide />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default onlineTutoring
